import { FuelTypography } from '@frete.com/fuel-react';
import GenericInfoItem from 'components/ui/GenericInfoItem';
import React, { FC } from 'react';
import { MainDestinationProps } from './types';

const MainDestination: FC<MainDestinationProps> = ({ mainDestination, hasItemBelow }) => (
  <GenericInfoItem title="Principal Rota" displayDivider={hasItemBelow}>
    <FuelTypography weight="medium">
      {mainDestination?.city}, {mainDestination?.state}
    </FuelTypography>
  </GenericInfoItem>
);

export default MainDestination;
